import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import { axiosInstnace as Axios } from '../../../util/util';
import { endPoints } from '../../../config';

const Modal = props => {
 
  const closePopup = () => {
    props.hide();
  }

  //Submit the approval
  const  handleSubmit =async () =>{

    const params = {
        _id:props.campaignId, 
        user_email : props.user_email,
      //vj 
        user_name  :  props.user_name,
        user_mobile  : props.user_mobile,
        user_company : props.user_company ,
        user_industry : props.user_industry,
        user_state : props.user_state,
        status:"Approve"
     };
 
    try {
      const response = await Axios.put(endPoints.addRemoveCampaign,params);
      if (response.data.statusCode===200) {
        props.hide();
        props.getCampaignlist(0, undefined, undefined, "Pending");
      } 
    } catch (error) {

    } 
   }

   //Return the popup for approve request
  return(
    props.isShowing?  <div>
 <div className="modal-overlay">
    <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
      <div className="modal approval">
        <div className="modal-head-cross rate-modal">
          <button type="button" className="modal-close-button" onClick={closePopup}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
       
        <div className="editNonFct-header modal-header" >
          <h4 className="popup-head rqst-head fct-head modal-title">Request Approval</h4>
        </div>
          <div className="approval-content modal-body">
      <div className="popup-container reqst-rejection">
         <p className="reqst-para approval-reqst">With your confirmation, this campaign will be approved</p>
         <div className="confirn-btn"><button className="cancel-reqst" onClick={props.hide}>CANCEL</button><button className="confirm-reqst" onClick={handleSubmit}>APPROVE</button></div>
      </div>
   </div>
      </div>
        </div>
      </div>
    </div>
  </div>:null
  )
}

export default Modal;


// WEBPACK FOOTER //
// ./web/components/admin/common/approveModel.js